import './Services.css';
import { IconMap, IconTruck, IconWarehouse } from './Icons';

const SECTIONS = [
  {
    number: '02',
    title: 'Área de Atuação',
    heading: (
      <>
        Cobertura em <span className="text-accent">todo o Brasil</span>
      </>
    ),
    text: 'Atuamos em 100% do território nacional, com rotas estratégicas e operação dedicada para atender demandas de transporte de cargas lotação em qualquer região do país.',
    icon: IconMap,
    image: `${process.env.PUBLIC_URL}/assets/img/on-parking-six.jpg`,
    imageAlt: 'Caminhão Tr Silva Bueno em estrada',
  },
  {
    number: '03',
    title: 'Nossa Frota',
    heading: (
      <>
        Veículos para <span className="text-accent">cada necessidade</span>
      </>
    ),
    text: 'Frota diversificada e moderna para garantir eficiência, segurança e capacidade em diferentes tipos de operação logística.',
    icon: IconTruck,
    fleet: ['Bi-trens', 'Carretas', 'Caminhões'],
    image: `${process.env.PUBLIC_URL}/assets/img/blog-post-five.jpg`,
    imageAlt: 'Frota de caminhões Tr Silva Bueno',
  },
  {
    number: '04',
    title: 'Infraestrutura e Armazenagem',
    heading: (
      <>
        Hub logístico em <span className="text-accent">Curitiba — PR</span>
      </>
    ),
    text: 'Centro de armazenagem com estrutura completa para recebimento, guarda e expedição de cargas, integrando transporte e depósito em uma única operação.',
    icon: IconWarehouse,
    image: `${process.env.PUBLIC_URL}/assets/img/from-our-blog-1.jpg`,
    imageAlt: 'Centro de armazenagem Tr Silva Bueno',
  },
];

function Services() {
  return (
    <section id="servicos" className="section-padding bg-dark-alt services-section" aria-labelledby="services-title">
      <div className="container">
        <div className="text-center mb-5">
          <p className="section-title">Nossos Serviços</p>
          <h2 id="services-title" className="section-heading">
            Soluções <span className="text-accent">logísticas</span> completas
          </h2>
          <div className="red-divider red-divider-center" />
          <p className="section-subtitle">
            Transporte rodoviário de carga, cobertura nacional e infraestrutura de
            armazenagem para empresas que buscam eficiência e confiabilidade.
          </p>
        </div>

        <div className="services-grid">
          {SECTIONS.map((section, index) => {
            const Icon = section.icon;
            const reversed = index % 2 !== 0;

            return (
              <article
                key={section.number}
                className={`service-block ${reversed ? 'service-block-reverse' : ''}`}
              >
                <div className="service-block-content">
                  <span className="section-badge">{section.number}</span>
                  <p className="section-title">{section.title}</p>
                  <h3 className="service-block-heading">{section.heading}</h3>
                  <div className="red-divider" />
                  <p className="service-block-text">{section.text}</p>

                  {section.fleet && (
                    <ul className="fleet-list">
                      {section.fleet.map((item) => (
                        <li key={item}>
                          <IconTruck className="fleet-icon" />
                          {item}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

                <div className="service-block-media">
                  <img
                    src={section.image}
                    alt={section.imageAlt}
                    loading="lazy"
                  />
                  <div className="service-block-icon">
                    <div className="icon-circle">
                      <Icon />
                    </div>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Services;
